import React, { useState } from 'react';
import { useAuth } from '../../../shared/contexts/AuthContext';
import { useTheme } from '../../../shared/contexts/ThemeContext';
import styles from './ProfileSettings.module.css';

interface ProfileSettingsProps {
  onClose: () => void;
  isUploadingCover: boolean;
}

const ProfileSettings: React.FC<ProfileSettingsProps> = ({ onClose, isUploadingCover }) => {
  const { logout } = useAuth();
  const { currentTheme, setTheme, availableThemes } = useTheme();
  
  const [showThemeSelector, setShowThemeSelector] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  if (showThemeSelector) {
    return (
      <div className={styles.settingsContainer}>
        <button 
          className={styles.settingsItem} 
          onClick={() => setShowThemeSelector(false)}
        >
          <span className={styles.settingsItemIcon}>
            <i className="ri-arrow-left-line"></i>
          </span>
          <span className={styles.settingsItemText}>Назад</span>
        </button>
        
        <div className={styles.settingsDivider} />
        
        <div className={styles.sectionTitle}>Выберите тему</div>
        
        {availableThemes.map((t) => (
          <button 
            key={t.name}
            className={`${styles.settingsItem} ${currentTheme === t.name ? styles.activeItem : ''}`} 
            onClick={() => setTheme(t.name)}
          >
            <span className={styles.settingsItemIcon}>
              <i className={t.icon}></i>
            </span>
            <span className={styles.settingsItemText}>{t.label}</span>
            {currentTheme === t.name && (
              <i className="ri-check-line" style={{ color: 'var(--primary-color)' }}></i>
            )}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.settingsContainer}>
      <button className={styles.settingsItem} onClick={onClose}>
        <span className={styles.settingsItemIcon}>
          <i className="ri-user-settings-line"></i>
        </span>
        <span className={styles.settingsItemText}>Редактировать профиль</span>
      </button>

      <button className={styles.settingsItem}>
        <span className={styles.settingsItemIcon}>
          <i className="ri-notification-3-line"></i>
        </span>
        <span className={styles.settingsItemText}>Уведомления</span>
      </button>

      <div className={styles.settingsDivider} />

      <button className={styles.settingsItem} onClick={() => setShowThemeSelector(true)}>
        <span className={styles.settingsItemIcon}>
          <i className="ri-palette-line"></i>
        </span>
        <span className={styles.settingsItemText}>Внешний вид</span>
        <span className={styles.settingsItemValue}>
          {availableThemes.find(t => t.name === currentTheme)?.label || 'Белая'}
        </span>
      </button>

      <div className={styles.settingsDivider} />

      <label
        className={styles.settingsItem}
        htmlFor="profile-cover-upload"
        style={isUploadingCover ? { pointerEvents: 'none', opacity: 0.6 } : undefined}
      >
        <span className={styles.settingsItemIcon}>
          {isUploadingCover ? <i className="ri-loader-4-line ri-spin"></i> : <i className="ri-image-edit-line"></i>}
        </span>
        <span className={styles.settingsItemText}>Изменить обложку</span>
      </label>

      <div className={styles.settingsDivider} />

      <button className={`${styles.settingsItem} ${styles.dangerItem}`} onClick={handleLogout}>
        <span className={styles.settingsItemIcon}>
          <i className="ri-logout-box-r-line"></i>
        </span>
        <span className={styles.settingsItemText}>Выйти</span>
      </button>
    </div>
  );
};

export default ProfileSettings;
